import React, { forwardRef, useState, useCallback } from 'react';
import { InputText, InputTextProps } from 'primereact/inputtext';
import { useTranslation } from 'localization';
import './PasswordInputAtom.scss';

export interface PasswordInputAtomProps extends Omit<InputTextProps, 'type'> {
  className?: string;
}

const PasswordInputAtom = forwardRef<HTMLDivElement, PasswordInputAtomProps>(
  ({ className = '', ...rest }, ref) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = useCallback(() => {
      setIsVisible((prev) => !prev);
    }, []);

    return (
      <div
        ref={ref}
        className={`password-input-atom ${className}`.trim()}
      >
        <InputText
          type={isVisible ? 'text' : 'password'}
          className="password-input-atom__input atlas-input-atom"
          {...rest}
        />
        <button
          type="button"
          className="password-input-atom__visibility-btn"
          onClick={toggleVisibility}
          disabled={rest.disabled}
          title={isVisible ? t('common.actions.hidePassword') : t('common.actions.showPassword')}
          aria-label={isVisible ? t('common.actions.hidePassword') : t('common.actions.showPassword')}
          aria-pressed={isVisible}
        >
          <i className={`pi ${isVisible ? 'pi-eye-slash' : 'pi-eye'}`} />
        </button>
      </div>
    );
  }
);

PasswordInputAtom.displayName = 'PasswordInputAtom';
export default PasswordInputAtom;
